export default __webpack_public_path__ + "static/media/painting26.95ba3066.jpeg";